export default __webpack_public_path__ + "static/kr-wolfe-logo-ac800d05831c824fd35be5a5f48c6cd8.png";